import { HOLDINGS_LABELS, HOLDINGS_ORDER } from '../campaigns-config';

interface HoldingsChipsProps {
  holdings: string[];
}

/**
 * The holdings "fingerprint" (SCRUM-206): a 22×22 mono chip per held product
 * code, rendered in HOLDINGS_ORDER. Only held codes appear; each chip's tooltip
 * is the full product label.
 */
export function HoldingsChips({ holdings }: HoldingsChipsProps) {
  const held = new Set(holdings);
  return (
    <div className="flex items-center gap-1">
      {HOLDINGS_ORDER.filter((code) => held.has(code)).map((code) => (
        <span
          key={code}
          title={HOLDINGS_LABELS[code] ?? code}
          className="bg-brand-dim border-border-accent text-brand-primary inline-flex h-[22px] w-[22px] items-center justify-center rounded-sm border font-mono text-[0.625rem] font-semibold tracking-[0.04em]"
        >
          {code}
        </span>
      ))}
    </div>
  );
}
